// extracted by mini-css-extract-plugin
export default {"container":"PlayerCreation_container__cVXzg","playerCreationTitle":"PlayerCreation_playerCreationTitle__wL01V"};